<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" v-for="calendarItem, index in calendarItems" :key="index">
        <a href="#" @click="openLink(calendarItem.link)">
          <b-card>
            <h3>{{calendarItem.name}}</h3>
          </b-card>
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";


export default {
  name: 'Tutorial',
  data () {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      tutorials:  [],
      pendingEmailConfirmation: false,
      calendarItems: []
    }
  },
  computed: {

  },
  methods: {
    openLink(url) {
      try {
        window.open(url, "_blank");
      } catch {
        //let destination = "/payments?action=OPEN_LINK&id=" + new Date().getTime() + "&url=" + encodeURI(url);
        //window.location.href = destination;
        alert("Erro 56.3, por favor entre em contato com o suporte.");
      }
    },
    getCalendar() {
      this.calendarItems = service.getCalendar().then(result => {
        this.calendarItems = result.calendar.items;
      })
    }
  },
  created() {
    this.getCalendar();
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
